import React, { useState } from "react";
import { Link } from "gatsby";
import Select from "react-dropdown-select";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import ScrollAnimation from "react-animate-on-scroll";
import "./ValuationInfo.scss";
import RequestCallbackForm from '../../forms/request-a-callback';

const RequestCallback = () => {
  const Departments = [
    { value: "Option", label: "Option" },
    { value: "Option1", label: "Option1" },
    { value: "Option2", label: "Option2" },
    { value: "Mortgage type", label: "Mortgage type" },
  ];
  const Branch = [
    { value: "Option", label: "Option" },
    { value: "Option1", label: "Option1" },
    { value: "Option2", label: "Option2" },
    { value: "Select branch", label: "Select branch" },
  ];
  return (
    <React.Fragment>
      <section className="valuation-info book-appointment-form callbackform" id="appointment-form">
        <Container>
          <Row>
            <Col>              
              

                <div className="valuation-box book">
                  <Link className="icons">
                    <i className="icon-callback">
                    </i>
                  </Link>
                  <h3>Request a Callback</h3>
                  <p>Fill in your details and one of our advisers will get in touch with you.</p>
                  <RequestCallbackForm />
                </div>
              
              <div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};
export default RequestCallback;
